(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
  // Select all the tabs and tab contents
  const tabs = document.querySelectorAll('.custom-tab');
  const tabContents = document.querySelectorAll('.custom__tab-content');
  const judgemeSection = document.getElementById('judgeme_product_reviews');

  // Function to set the first tab as active on page load
  window.addEventListener('DOMContentLoaded', (event) => {
    // Set the first tab to active
    if (tabs.length > 0) {
      tabs[0].classList.add('active');
      const firstTabContentId = tabs[0].dataset.contentId;
      const firstTabContent = document.getElementById(firstTabContentId);
      if (firstTabContent) {
        firstTabContent.classList.add('active');
      }
    }
  });

  // Event listener for tab clicks
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      
      // Get the content ID from the clicked tab
      const contentId = this.dataset.contentId;
      const content = document.getElementById(contentId);

      // Remove the 'active' class from all tab contents and tabs
      tabContents.forEach(function(content) {
        content.classList.remove('active');
      });

      tabs.forEach(function(tab) {
        tab.classList.remove('active');
      });

      // Show the correct content and add 'active' to the clicked tab
      this.classList.add('active');
      content.classList.add('active');

      // Check if the "Product Reviews" tab is clicked
      if (contentId === 'judgeme_product_reviews') {
        judgemeSection.style.display = 'block'; // Show the reviews section
      } else {
        judgemeSection.style.display = 'none'; // Hide the reviews section
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
